import React, { useState } from "react"
import { Box, InputAdornment, TextField } from "@mui/material"
import { FxLabel } from "../label/FxLabel"
import { FxPasswordProps } from "./FxPassword.props"
import { FxValidation } from "../validation/FxValidation"
import { FxIcon } from "../icon/FxIcon"

/**
 *
 * @param label
 * @param name
 * @param value
 * @param onValueChange
 * @param variant
 * @param size
 * @param className
 * @param info
 * @param disabled
 * @param placeholder
 * @param fullWidth
 * @param validations
 * @param validationResult
 * @param style
 * @param customErrors
 * @param labelAlignment
 * @constructor
 */
export const FxPassword = ({
  label,
  name,
  value,
  path,
  onValueChange,
  variant = "outlined",
  size = "small",
  className,
  info,
  disabled,
  placeholder,
  fullWidth = false,
  validations,
  validationResult,
  style,
  customErrors,
  labelAlignment = 'top',
  textBoxLabel,
  sx = {}
}: FxPasswordProps) => {
  const [onBlur, setOnBlur] = useState(false)
  let inputProps = {};

  const defaultEndIcon: any = "far fa-eye-slash font-12";
  const [endIcon, setEndIcon] = useState(defaultEndIcon);

  const defaultType: any = "password";
  const [type, setType] = useState(defaultType);

  const onClickEndIcon = () => {
    if (type == 'password') {
      setEndIcon("far fa-eye font-12");
      setType("text");
    } else if (type == 'text') {
      setEndIcon("far fa-eye-slash font-12");
      setType("password");
    }
  }

  inputProps = {
    endAdornment: (
      <InputAdornment position="end">
        <FxIcon className="pointer" icon={endIcon} onClick={onClickEndIcon} />
      </InputAdornment>
    ),
  };
  /**
   *
   * @param event
   */
  const onChange = (event: any) => {
    const data = { name, value: event.target.value, path }
    if (onValueChange) onValueChange(data)
  }

  const isMandatory = () => {
    if (validations && validations.length > 0) {
      return validations.includes('required')
    }
  };

  const showTextBoxLbl = () => {
    if (isMandatory() && textBoxLabel) {
      return <>
        {textBoxLabel} <span className="text-danger">*</span>
      </>
    } else if(textBoxLabel){
      return <>{textBoxLabel}</>
    }
  }

  textBoxLabel = showTextBoxLbl()

  return (
    <>
      <div className={`fx-input ${labelAlignment == 'top' ? 'alignmentTop' : 'alignmentLeft'}`}>
        {label && <div><FxLabel info={info} label={label} validations={validations} /></div>}
        <TextField
          className={className}
          type={type}
          label={textBoxLabel}
          size={size}
          name={name}
          value={value}
          onChange={onChange}
          variant={variant === "outlined" ? "outlined" : "standard"}
          disabled={disabled}
          fullWidth={fullWidth}
          placeholder={placeholder}
          style={style}
          onFocus={() => setOnBlur(false)}
          onBlur={() => setOnBlur(true)}
          InputProps={inputProps}
          sx={sx}
        />
      </div>
      <FxValidation name={name}
        value={value}
        validations={validations}
        validationResult={validationResult}
        onBlur={onBlur}
        customErrors={customErrors} />
    </>
  )
}
